<template>
  <!-- Buscador de las páginas de Servicios y Blog (panel: Mostrar barra de búsqueda) -->
  <div class="n2-buscador">
    <label class="n2-buscador__campo">
      <v-icon size="20" aria-hidden="true">mdi-magnify</v-icon>
      <input :value="modelValue" type="search" :placeholder="placeholder" :aria-label="placeholder"
        @input="$emit('update:modelValue', $event.target.value)" />
      <button v-if="modelValue" type="button" class="n2-buscador__borrar" :aria-label="tSolicitud('Borrar búsqueda')" @click="$emit('update:modelValue', '')">
        <v-icon size="18">mdi-close</v-icon>
      </button>
    </label>
    <div v-if="consulta" class="n2-buscador__pie">
      <span v-if="sinResultados">{{ tSolicitud('No hay resultados para «{q}».', { q: consulta }) }}</span>
      <!-- Como en la plantilla de siempre: si el asistente está activo, se le puede preguntar lo que se ha buscado -->
      <button v-if="NOTARIA?.Personalizar?.ChatbotActivo && !store.chatbotOverQuota" type="button" class="n2-boton n2-boton--linea"
        @click="preguntar">
        <v-icon size="18">mdi-robot-outline</v-icon> {{ tSolicitud('Preguntar al asistente') }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { t as tSolicitud } from '../../composables/solicitudTextos'

const props = defineProps({
  modelValue: { type: String, default: '' },
  placeholder: { type: String, default: '' },
  sinResultados: { type: Boolean, default: false },
})
defineEmits(['update:modelValue'])

const store = useStore()
const { NOTARIA } = storeToRefs(store)
const consulta = computed(() => props.modelValue.trim())

function preguntar() {
  store.pendingChatQuery = consulta.value
  store.isChatbotOpen = true
}
</script>
